package co.maytes.standupbot.dashboard.stores

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import com.kttipay.mvi.api.Container
import com.kttipay.mvi.api.StoreScope
import com.kttipay.mvi.dsl.store
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch

class UiContainer(
    private val scope: CoroutineScope,
) : Container<UiContract.State, UiContract.Intent, UiContract.Action> {

    override val store = scope.store<UiContract.State, UiContract.Intent, UiContract.Action>(
        initialState = UiContract.State(),
    ) {
        configure(name = "Ui")
        logging()
        reduce { intent ->
            when (intent) {
                is UiContract.Intent.ShowToast -> updateState { copy(toast = intent.toast) }
                UiContract.Intent.DismissToast -> updateState { copy(toast = null) }
            }
        }
    }

    var currentToast: Toast? by mutableStateOf(null)
        private set

    private var nextToastId = 0L

    init {
        scope.launch {
            store.state.collect { currentToast = it.toast }
        }
    }

    fun showToast(message: String, kind: ToastKind = ToastKind.Info) {
        store.intent(UiContract.Intent.ShowToast(Toast(nextToastId++, message, kind)))
    }

    fun clearToast() {
        store.intent(UiContract.Intent.DismissToast)
    }
}
